var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCnhCrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 439,
    viewBox: "0 0 317 439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.158 0.839355H0.842529V438.161H316.158V0.839355Z",
    stroke: "#70BE44",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.383 53.4584H52.4366V67.9962H299.383V53.4584Z",
    stroke: "#70BE44",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 74H159V186H299V74Z",
    stroke: "#70BE44",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 195H53V209H299V195Z",
    stroke: "#70BE44",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.246 232.677H53.4216V303.275H299.246V232.677Z",
    stroke: "#70BE44",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.65 347.87H54.5438V362.408H229.65V347.87Z",
    stroke: "#70BE44",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.931 347.87H233.583V362.408H300.931V347.87Z",
    stroke: "#70BE44",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8778 334.59H240.039",
    stroke: "#70BE44",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8778 389.672H240.039",
    stroke: "#70BE44",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.744 74.8468H53.4216V185.838H153.744V74.8468Z",
    stroke: "#70BE44",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.745 178.958C152.678 178.397 151.559 177.927 150.396 177.561L134.843 172.653C134.539 172.397 134.21 172.177 133.849 172.003L119.91 165.178V158.702C126.308 154.154 130.476 147.036 131.281 139.259C134.265 138.704 136.53 136.094 136.53 132.963C136.53 125.337 136.53 115.524 136.53 108.537C136.53 103.086 132.076 98.6514 126.605 98.6514H126.407C126.381 93.2237 121.939 88.8153 116.485 88.8153H91.0513C80.2813 88.8153 71.5224 97.542 71.5224 108.273V132.963C71.5224 136.094 73.7901 138.707 76.7719 139.259C77.5764 147.036 81.7445 154.154 88.1424 158.702V165.181L74.2069 172.003C73.8455 172.18 73.5132 172.4 73.2101 172.656L57.6628 177.561C56.1675 178.031 54.7451 178.67 53.4131 179.463V185.768C55.0599 184.232 57.0303 183.076 59.196 182.393L71.9247 178.377C71.9567 178.444 71.9888 178.513 72.0209 178.58L75.0289 184.391C75.2737 184.865 75.2183 185.425 74.9006 185.84H80.2463C80.5902 182.19 77.3549 178.586 76.6407 176.454L86 171.872C85.0294 176.129 85.0294 180.915 85.6357 185.84H92.1093L90.5354 183.874C90.0428 178.914 90.3284 174.732 91.3923 171.381L100.658 181.789L95.7936 185.837H103.725L104.278 185.376L104.821 185.837H112.644L107.878 181.778L116.669 171.477C117.701 174.787 117.981 178.905 117.508 183.779L115.841 185.84H122.399C123.006 180.915 123.003 176.129 122.035 171.872L131.397 176.454C130.68 178.589 127.448 182.193 127.792 185.84H133.137C132.817 185.425 132.764 184.865 133.009 184.391L136.017 178.58C136.052 178.513 136.084 178.444 136.113 178.374L148.848 182.39C150.635 182.954 152.284 183.837 153.733 184.99V178.958H153.745ZM114.827 161.551V165.834L104.273 178.2L93.2315 165.799V161.551C99.9937 164.443 107.817 164.548 114.827 161.551ZM76.6116 108.273C76.6116 100.339 83.0911 93.8829 91.0542 93.8829H116.488C119.155 93.8829 121.327 96.0436 121.327 98.7037C121.327 101.468 123.586 103.722 126.363 103.722H126.611C129.278 103.722 131.45 105.883 131.45 108.543V122.067H128.893C127.462 122.067 126.299 120.908 126.299 119.482V116.683C126.299 111.27 120.995 107.451 115.835 109.15C108.225 111.656 99.8422 111.656 92.2259 109.15C87.0668 107.451 81.7649 111.273 81.7649 116.686V119.485C81.7649 120.911 80.6019 122.07 79.1707 122.07H76.6145V108.278L76.6116 108.273ZM81.762 137.877C81.6366 135.873 79.9606 134.302 77.9553 134.302C77.215 134.302 76.6116 133.701 76.6116 132.963V127.129H79.1678C83.403 127.129 86.8453 123.696 86.8453 119.477V116.677C86.8453 114.74 88.7399 113.331 90.6374 113.956C99.2767 116.799 108.79 116.799 117.43 113.953C119.292 113.34 121.21 114.72 121.21 116.677V119.477C121.21 123.696 124.655 127.129 128.888 127.129H131.444V132.963C131.444 133.701 130.841 134.302 130.103 134.302C128.095 134.302 126.422 135.87 126.294 137.877C125.848 144.928 122 151.413 116.002 155.223C108.718 159.849 99.3408 159.849 92.0569 155.223C86.0583 151.413 82.2079 144.928 81.762 137.877Z",
    fill: "#70BE44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317,
    height: 439,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnhCrop);
export default __webpack_public_path__ + "static/media/cnhCrop.feacd21d90aa42c56b8ef0eb6eb15e7b.svg";
export { ForwardRef as ReactComponent };